import { h as o } from "vue";
import { o as e } from "./DownloadIcon.DHCHRETy.js";
const d = (t, { attrs: r }) => {
  t = { ...e(), ...t };
  const { width: i, height: s } = t;
  return o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20.243 11.621",
      width: `${i}`,
      height: `${s}`,
      class: t.class ?? "",
      "aria-hidden": r["aria-hidden"] ?? "true"
    },
    o("path", {
      fill: "none",
      stroke: `${r["stroke-color"] ?? "#222"}`,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": `${r["stroke-width"] ?? "3"}`,
      d: "m18.121 2.121-8 8-8-8"
    })
  );
};
export {
  d
};
